var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBooklet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.2H9.22222C8.92754 7.2 8.64492 7.32643 8.43655 7.55147C8.22817 7.77652 8.11111 8.08174 8.11111 8.4C8.11111 8.71826 8.22817 9.02348 8.43655 9.24853C8.64492 9.47357 8.92754 9.6 9.22222 9.6H17V17.4C17 17.5591 16.9415 17.7117 16.8373 17.8243C16.7331 17.9368 16.5918 18 16.4444 18H9.22222C8.63285 18 8.06762 17.7471 7.65087 17.2971C7.23413 16.847 7 16.2365 7 15.6V8.4C7 7.76348 7.23413 7.15303 7.65087 6.70294C8.06762 6.25286 8.63285 6 9.22222 6H16.4444C16.5918 6 16.7331 6.06321 16.8373 6.17574C16.9415 6.28826 17 6.44087 17 6.6V7.2ZM8.11111 15.6C8.11111 15.9183 8.22817 16.2235 8.43655 16.4485C8.64492 16.6736 8.92754 16.8 9.22222 16.8H15.8889V10.8H9.22222C8.83212 10.8007 8.4488 10.6899 8.11111 10.479V15.6ZM16.4444 9H9.22222C9.07488 9 8.93357 8.93679 8.82939 8.82426C8.7252 8.71174 8.66667 8.55913 8.66667 8.4C8.66667 8.24087 8.7252 8.08826 8.82939 7.97574C8.93357 7.86321 9.07488 7.8 9.22222 7.8H16.4444V9Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBooklet);
export default __webpack_public_path__ + "static/media/IconBooklet.3da06116.svg";
export { ForwardRef as ReactComponent };